import { InjectionToken } from '@angular/core';
import { IStorage } from '@/core/interface/storage-service.interface';

export const STORAGE_SERVICE_TOKEN =
    new InjectionToken<IStorage>('STORAGE_SERVICE_TOKEN');
